import { Link } from "react-router-dom";
import type { ProductRecord } from "@lib/schema";

interface ProductCardProps {
  product: ProductRecord & { summary?: string | null };
}

export function ProductCard({ product }: ProductCardProps) {
  return (
    <article className="product-card">
      <h3>
        <Link to={`/product/${product.slug}`}>{product.name}</Link>
      </h3>
      <p className="product-card__meta">
        {product.brand} • {product.category}
      </p>
      <p className="product-card__summary">{product.summary ?? "Research in progress."}</p>
      <Link to={`/compare?ids=${product.slug},`} className="product-card__compare">
        Compare
      </Link>
    </article>
  );
}
